import { render } from "./Entrance.vue?vue&type=template&id=dca46418&scoped=true"
import script from "./Entrance.vue?vue&type=script&lang=js"
export * from "./Entrance.vue?vue&type=script&lang=js"

import "./Entrance.vue?vue&type=style&index=0&id=dca46418&scoped=true&lang=css"

import exportComponent from "/Users/xueke/Develop/Work/rococo/weshow-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca46418"]])

export default __exports__